import { useQuery } from "@tanstack/react-query";
import { getCatalog } from "../services/catalog-service";

export const catalogKeys = {
  all: ["catalog"] as const,
};

export const useCatalog = () =>
  useQuery({
    queryKey: catalogKeys.all,
    queryFn: getCatalog,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 1,
  });
